import React from 'react';

const ProductivityFactors = ({ sampleDataFallback }) => (
  <div className="space-y-6">
    <div className="flex items-center justify-between">
      <h2 className="text-2xl font-bold text-slate-800 dark:text-white">
        🔑 Key Productivity Factors
      </h2>
      <span className="bg-purple-100 dark:bg-purple-900/40 text-purple-800 dark:text-purple-300 px-3 py-1 rounded-full text-sm font-medium">
        Premium Feature
      </span>
    </div>

    <p className="text-gray-600 dark:text-gray-400">
      Ties energy savings to business performance improvements
    </p>

    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      {sampleDataFallback.productivityFactors.map((factor, index) => (
        <div
          key={index}
          className="bg-white dark:bg-gray-800 p-6 rounded-lg border border-gray-200 dark:border-gray-700 hover:shadow-lg transition-shadow"
        >
          <div className="text-center mb-4">
            <p className="text-3xl font-bold text-emerald-600 dark:text-emerald-400">
              +{factor.impact}%
            </p>
            <p className="text-sm text-gray-500 dark:text-gray-400">
              {factor.confidenceLevel}% confidence: {factor.confidence}
            </p>
          </div>

          <h3 className="text-lg font-semibold text-slate-800 dark:text-white mb-2 text-center">
            {factor.name}
          </h3>
          <p className="text-sm text-gray-600 dark:text-gray-400 text-center">
            {factor.description}
          </p>
        </div>
      ))}
    </div>

    <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-700 rounded-lg p-4 text-center">
      <p className="text-sm text-blue-800 dark:text-blue-300">
        <span className="font-medium">Data Source:</span> Rely Ability Statistical
        Analysis Engine (RASA) + DOE datasets
      </p>
    </div>
  </div>
);

export default ProductivityFactors;


